/* 
The DocToLib app is a is a template for interfaces to the GM AI. It can be configured using the following
JSON structure in the calling .html.erb page:
{
  "config": {
    "title": "GestaltMatcher DocToLib App",
    "description": "A simple app to demonstrate the DocToLib interface.",
    "apiUrl": "/api/v1/doc_to_lib",
    "submitUrl": "/doc_to_lib/submit",
    "fields": [
      {"name": "title", "type": "text", "label": "Title"},
      {"name": "description", "type": "textarea", "label": "Description"},
      {"name": "file", "type": "file", "label": "Upload File"}
    ]
  },
  "railsData": {
    // additional data passed from Rails
  }
}
*/

import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import axios from 'axios';

// import Basics from '../app_generator/components/Basics/Basics';
// import Hpo from '../app_generator/components/hpo/hpo';
// import Variants from '../app_generator/components/Variants/Variants';
// import QR from '../app_generator/components/QR/QR';
// import About from '../app_generator/components/About/About';
// import BrowserTest from '../app_generator/lib/browser-test';

// import Tabs from '../components/UI/Tabs/Tabs';

// import TestForm from '../UI/Form/TestForm';
// import ApiAccess from '../components/Test/api_access';

// import * as actions from '../app_generator/store/actions/index';

import PingUIn from '../../Components/UI/PingUIn/PingUIn';
import Button from '../../Components/UI/Button/Button';

import SubmitPage from './Pages/SubmitPage';

import { configActions } from '../../lib/configStore';

import './DocToLib.css';


function DocToLib( props ) {
  const dispatch = useDispatch();

  //console.log(props.railsData)
  
  if (props.railsData) {
    dispatch( configActions.store( props.railsData ) );
  }

  return (
    <div className="App">
            <div className="jumbotron">
              <h3>{props.railsData.config.title}</h3>
            </div>
      <SubmitPage railsData = {props.railsData}/>
    </div>
  );
}

// const mapDispatchToPros = dispatch => {
//   return {
//     setConfigHash: (hash) => dispatch( actions.setConfigHash(hash) )
//   }
// }

// export default connect( null, mapDispatchToPros )( DocToLib );
export default DocToLib;


/*
      <Tabs titles = {['Basic', 'HPO', 'Variants', 'QR']}>
        <Basics config={props.railsData?.config} />
        <Hpo />
        <Variants />
        <QR demo={props.demo} />
      </Tabs><About />
<BrowserTest />
<TestForm />
<ApiAccess /> 
*/
